import { useEffect, useState } from 'react';

export const matchesQuery = (query: string): boolean => (
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches
);

const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState<boolean>(() => matchesQuery(query));

    useEffect(() => {
        if (typeof window.matchMedia !== 'function') {
            return undefined;
        }
        const list = window.matchMedia(query);
        const onChange = (): void => setMatches(list.matches);
        onChange();
        list.addEventListener('change', onChange);
        return () => list.removeEventListener('change', onChange);
    }, [query]);

    return matches;
};

export default useMediaQuery;
